import { render, staticRenderFns } from "./SessionContent.vue?vue&type=template&id=c8a1bdf0&scoped=true&"
import script from "./SessionContent.vue?vue&type=script&lang=js&"
export * from "./SessionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a1bdf0",
  null
  
)

export default component.exports